/* cl-focal-pdp (nubelle): da vida ao buybox copiado do Focal 12 do concorrente (bloco cl_pdp do
   main-product nativo). O JS do tema dele (variant-picker, flickity, quantity-selector) nao existe
   aqui; o seletor visivel e o do app Rio (PwzrGrid, markup estatico).
   1. Rio: clique escolhe o valor, troca o estilo selecionado/nao-selecionado (diff dos inline styles
      que o app gravou), resolve a variante NOSSA e escreve no input[name=id] do form unico.
   2. Preco/compare/"Spare" pela variante (money_format da loja), ATC esgotado, ?variant= na URL.
   3. Galeria mobile: o flickity vira trilho com scroll-snap (toque nativo, arraste/setas/miniaturas).
   4. quantity-selector +/-. */
(function () {
  'use strict';
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), p = v.split('.');
    var thou = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var thouC = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thou + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, thou)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, thouC)
      .replace(/\{\{\s*amount\s*\}\}/, thouC + '.' + p[1]);
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').replace(/ö/g, 'o').replace(/ä/g, 'a').replace(/ü/g, 'u')
      .normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
  }
  function styleMap(el) {
    var m = {}, s = el.style;
    for (var i = 0; i < s.length; i++) m[s[i]] = s.getPropertyValue(s[i]);
    return m;
  }
  function labelSpan(btn) { return btn.querySelector('[class*="PwzrButton-label"] > span'); }

  function initRioGroup(g, selectedValue) {
    var btns = [].slice.call(g.querySelectorAll('[role="button"][data-option-value]'));
    if (!btns.length) return null;
    var sel = btns.filter(function (b) { return norm(b.getAttribute('data-option-value')) === norm(selectedValue); })[0] || btns[0];
    var other = btns.filter(function (b) { return b !== sel; })[0];
    var swatch = g.getAttribute('data-option-type') === 'swatch';
    var skip = swatch ? { 'background-image': 1, 'background-color': 1, 'background-repeat': 1, 'background-position': 1, 'background-size': 1 } : { 'background-image': 1 };
    var on = {}, off = {}, lon = {}, loff = {};
    if (other) {
      var a = styleMap(sel), b = styleMap(other);
      Object.keys(a).concat(Object.keys(b)).forEach(function (k) {
        if (skip[k] || a[k] === b[k]) return;
        on[k] = a[k] || ''; off[k] = b[k] || '';
      });
      var la = labelSpan(sel), lb = labelSpan(other);
      if (la && lb) {
        var sa = styleMap(la), sb = styleMap(lb);
        Object.keys(sa).concat(Object.keys(sb)).forEach(function (k) {
          if (sa[k] !== sb[k]) { lon[k] = sa[k] || ''; loff[k] = sb[k] || ''; }
        });
      }
    }
    return {
      el: g, btns: btns, name: g.getAttribute('data-option') || g.getAttribute('aria-label') || '',
      select: function (btn) {
        btns.forEach(function (b) {
          var st = b === btn ? on : off, ls = b === btn ? lon : loff;
          Object.keys(st).forEach(function (k) { b.style.setProperty(k, st[k]); });
          var sp = labelSpan(b);
          if (sp) Object.keys(ls).forEach(function (k) { sp.style.setProperty(k, ls[k]); });
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      }
    };
  }

  function boot(host) {
    if (host.__clFocal) return;
    var data;
    try { data = JSON.parse(host.querySelector('script[data-cl-product]').textContent); } catch (e) { return; }
    host.__clFocal = true;
    var P = data.product, fmt = data.money || '{{amount}}', vmedia = data.vmedia || {};
    var forms = [].slice.call(host.querySelectorAll('form[action="/cart/add"]'));
    var main = forms.filter(function (f) { return /product-form-main/.test(f.getAttribute('id')); })[0] || forms.filter(function (f) { return !/installment/.test(f.getAttribute('id')); })[0];
    var idInput = main && main.querySelector('input[name="id"]');
    var cur = null;
    P.variants.forEach(function (v) { if (idInput && String(v.id) === idInput.value) cur = v; });
    if (!cur) cur = P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    if (idInput) idInput.value = cur.id;
    var names = (P.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var selected = cur.options.slice();

    // --- Rio
    var groups = [];
    host.querySelectorAll('.rio-options [data-option]').forEach(function (g) {
      var name = g.getAttribute('data-option');
      var idx = names.map(norm).indexOf(norm(name));
      if (idx < 0) {   // nome diferente: o grupo cujos valores existem nessa opcao
        var vals = [].map.call(g.querySelectorAll('[data-option-value]'), function (b) { return norm(b.getAttribute('data-option-value')); });
        for (var i = 0; i < names.length && idx < 0; i++) {
          var ov = P.variants.map(function (v) { return norm(v.options[i]); });
          if (vals.length && vals.every(function (x) { return ov.indexOf(x) > -1; })) idx = i;
        }
      }
      var G = initRioGroup(g, idx > -1 ? selected[idx] : '');
      if (!G) return;
      G.idx = idx;
      groups.push(G);
    });
    var titles = [].slice.call(host.querySelectorAll('.rio-product-option-title-option-value'));

    function findVariant(opts) {
      var exact = P.variants.filter(function (v) { return v.options.every(function (o, i) { return norm(o) === norm(opts[i]); }); })[0];
      if (exact) return exact;
      return null;
    }
    function apply(v, scroll) {
      if (!v) return;
      cur = v;
      forms.forEach(function (f) { var i = f.querySelector('input[name="id"]'); if (i) i.value = v.id; });
      host.querySelectorAll('.product-meta .price-list .price--highlight, .product-meta .price-list .price--large, .product-meta .price-list .clx-price--large').forEach(function (el) {
        var h = el.querySelector('.visually-hidden');
        el.textContent = ''; if (h) el.appendChild(h); el.appendChild(document.createTextNode(money(v.price, fmt)));
      });
      host.querySelectorAll('.product-meta .price-list .price--compare').forEach(function (el) {
        var h = el.querySelector('.visually-hidden');
        el.textContent = ''; if (h) el.appendChild(h);
        el.appendChild(document.createTextNode(v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : ''));
        el.style.display = v.compare_at_price > v.price ? '' : 'none';
      });
      host.querySelectorAll('.product-meta__label-list .label--highlight').forEach(function (el) {
        if (!el.__clTpl) el.__clTpl = el.textContent.replace(/(?:R\$\s*|€\s*)?[\d.,]+\s*€?\s*$/, ''); if (!/\s$/.test(el.__clTpl)) el.__clTpl += ' ';
        if (v.compare_at_price > v.price) { el.textContent = el.__clTpl + money(v.compare_at_price - v.price, fmt); el.style.display = ''; }
        else el.style.display = 'none';
      });
      var atc = main && main.querySelector('button[type="submit"]');
      if (atc) {
        atc.disabled = !v.available;
        var t = atc.querySelector('.loader-button__text');
        if (t) { if (!t.__clTxt) t.__clTxt = t.textContent; t.textContent = v.available ? t.__clTxt : 'Ausverkauft'; }
      }
      groups.forEach(function (G) {
        if (G.idx < 0) return;
        var b = G.btns.filter(function (x) { return norm(x.getAttribute('data-option-value')) === norm(v.options[G.idx]); })[0];
        if (b) G.select(b);
      });
      titles.forEach(function (t, i) {
        var G = groups[i];
        if (G && G.idx > -1) t.textContent = v.options[G.idx];
      });
      host.querySelectorAll('.product-form__option-selector').forEach(function (sel, i) {
        var s = sel.querySelector('.product-form__option-value');
        if (s && v.options[i] != null) s.textContent = v.options[i];
      });
      // radios nativos (ocultos) do Focal: mantem coerente
      host.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (r) {
        var pos = +r.getAttribute('data-option-position') - 1;
        var lab = r.getAttribute('aria-label') || r.value;
        r.checked = norm(lab) === norm(v.options[pos]);
      });
      if (scroll && vmedia[v.id]) showMedia(vmedia[v.id], true);
      try {
        var u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
    host.addEventListener('click', function (e) {
      var btn = e.target.closest('.rio-options [role="button"][data-option-value]');
      if (!btn || !host.contains(btn)) return;
      var G = groups.filter(function (x) { return x.el.contains(btn); })[0];
      if (!G) return;
      e.preventDefault();
      if (G.idx < 0) { G.select(btn); return; }
      var opts = cur.options.slice();
      opts[G.idx] = (P.variants.map(function (v) { return v.options[G.idx]; }).filter(function (o) { return norm(o) === norm(btn.getAttribute('data-option-value')); })[0]) || btn.getAttribute('data-option-value');
      var v = findVariant(opts);
      if (!v) {   // combinacao inexistente: a primeira variante com esse valor
        v = P.variants.filter(function (x) { return norm(x.options[G.idx]) === norm(opts[G.idx]) && x.available; })[0]
          || P.variants.filter(function (x) { return norm(x.options[G.idx]) === norm(opts[G.idx]); })[0];
      }
      apply(v, G.el.getAttribute('data-option-type') === 'swatch');
    });
    host.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.rio-options [role="button"][data-option-value]')) { e.preventDefault(); e.target.click(); }
    });
    // variant-picker NATIVO do Focal (visivel quando o produto nao tem opcoes no Rio: o "Gratis Bundle")
    host.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('input[type="radio"][data-option-position]')) return;
      var pos = +r.getAttribute('data-option-position') - 1;
      var val = r.getAttribute('aria-label') || (r.nextElementSibling && r.nextElementSibling.textContent.trim()) || r.value;
      var opts = cur.options.slice();
      opts[pos] = P.variants.map(function (v) { return v.options[pos]; }).filter(function (o) { return norm(o) === norm(val); })[0] || val;
      var v = findVariant(opts) || P.variants.filter(function (x) { return norm(x.options[pos]) === norm(opts[pos]); })[0];
      apply(v, pos === 0);
    });

    // --- replica do widget Kaching Bundles (so onde o app esta ativo no concorrente)
    var kb = host.querySelector('[data-cl-kaching]');
    if (kb) initKaching(kb, P, fmt, host);

    // --- quantidade
    host.querySelectorAll('quantity-selector, cl-quantity-selector, .quantity-selector').forEach(function (q) {
      var input = q.querySelector('input'), bs = q.querySelectorAll('button');
      if (!input || bs.length < 2) return;
      bs[0].addEventListener('click', function () { input.value = Math.max(+input.min || 1, (+input.value || 1) - 1); });
      bs[1].addEventListener('click', function () { input.value = (+input.value || 1) + 1; });
    });

    // --- galeria mobile: trilho com scroll-snap
    var list = host.querySelector('.product__media-list, .clx-product__media-list');
    var items = list ? [].slice.call(list.querySelectorAll('.product__media-item:not(.is-filtered), .clx-product__media-item:not(.is-filtered)')) : [];
    var thumbs = [].slice.call(host.querySelectorAll('.product__thumbnail-item[data-media-id]'));
    var prev = host.querySelector('.product__media [data-action="prev"], .clx-product__media [data-action="prev"], .product__media-nav [data-action="prev"]');
    var next = host.querySelector('.product__media [data-action="next"], .clx-product__media [data-action="next"], .product__media-nav [data-action="next"]');
    var at = 0;
    function mark(i) {
      at = i;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });  /* Focal: borda casa [aria-current] (presenca) */
      items.forEach(function (it, k) { it.classList.toggle('is-selected', k === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= items.length - 1;
      var th = thumbs[i], box = th && th.closest('.product__thumbnail-list');
      if (th && box && box.scrollWidth > box.clientWidth) {
        box.scrollTo({ left: th.offsetLeft - (box.clientWidth - th.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    function go(i, smooth) {
      if (!list || !items.length) return;
      i = Math.max(0, Math.min(items.length - 1, i));
      list.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }
    function showMedia(mid, smooth) {
      var i = items.map(function (it) { return it.getAttribute('data-media-id'); }).indexOf(String(mid));
      if (i > -1) go(i, smooth);
    }
    if (list && items.length > 1) {
      list.classList.add('cl-flk');
      list.addEventListener('scroll', function () {
        var w = items[0].offsetWidth || 1;
        var i = Math.round(list.scrollLeft / w);
        if (i !== at) mark(i);
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function (e) { e.preventDefault(); showMedia(t.getAttribute('data-media-id'), true); });
      });
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(at - 1, true); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(at + 1, true); });
      mark(0);
    }
    // --- guia de tamanhos (replica do modal do Kiwi Sizing): abre no link "Größentabelle"
    // player da lista de videos (nvl): o script dele ja guardou as referencias no parse; o modal fixed preso no
    // contexto de empilhamento do buybox ficava ATRAS do header (X inclicavel) -> portal no <body> com as classes
    // do wrapper cl-sec-* (o CSS escopado continua casando; display:contents nao cria caixa)
    host.querySelectorAll('[data-nvl-modal]').forEach(function (m) {
      var w = m.closest('[class*="cl-sec-"]'), box = document.createElement('div');
      box.className = (w ? w.className + ' ' : '') + 'cl-nvl-portal';
      box.style.cssText = 'display:contents';
      box.appendChild(m); document.body.appendChild(box);
    });
    // estado do proprio app: modal + backdrop filhos do <body>, html.vanilla-modal(.kiwi-sizing-modal-visible)
    var kiwi = host.querySelector('[data-cl-kiwi]');
    var kModal = kiwi && kiwi.querySelector('.kiwi-sizing-modal');
    if (kModal) {
      var kBack = kiwi.querySelector('.ks-modal-backdrop');
      document.querySelectorAll('body > .kiwi-sizing-modal[data-cl-kiwi-moved], body > .ks-modal-backdrop[data-cl-kiwi-moved]').forEach(function (n) { n.remove(); });
      [kBack, kModal].forEach(function (n) { if (n) { n.setAttribute('data-cl-kiwi-moved', ''); document.body.appendChild(n); } });
      kiwi.remove();
      var de = document.documentElement;
      de.classList.add('vanilla-modal'); document.body.classList.add('kiwi-modal-style-0');
      var lastFocus = null;
      var isOpen = function () { return de.classList.contains('kiwi-sizing-modal-visible'); };
      var openK = function (e) {
        if (e) e.preventDefault();
        lastFocus = document.activeElement;
        kModal.scrollTop = 0;
        de.classList.add('kiwi-sizing-modal-visible');
        setTimeout(function () { try { kModal.focus({ preventScroll: true }); } catch (x) {} }, 50);
      };
      var closeK = function () {
        de.classList.remove('kiwi-sizing-modal-visible');
        if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (x) {}
      };
      host.addEventListener('click', function (e) { if (e.target.closest('.ks-chart-modal-link, .ks-chart-modal-button, .ks-chart-container [role="button"]')) openK(e); });
      host.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.ks-chart-modal-link, .ks-chart-modal-button')) openK(e); });
      kModal.addEventListener('click', function (e) {
        if (e.target === kModal || e.target.closest('[data-modal-close], .ks-modal-close')) closeK();
      });
      if (kBack) kBack.addEventListener('click', closeK);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) closeK(); });
    }
    // estado inicial: variante da URL (?variant=) ou a do form
    var q = null;
    try { q = new URL(location.href).searchParams.get('variant'); } catch (e) {}
    var qv = q && P.variants.filter(function (v) { return String(v.id) === q; })[0];
    apply(qv || cur, !!qv);
  }
  /* Kaching: barra selecionada (--selected), por item um dropdown de cor (combobox desenhado) + select de
     tamanho; o ATC monta um /cart/add.js com uma linha por item (+ o brinde da barra). Os descontos
     automaticos da loja (setup_discounts.py) cobram o preco da barra. */
  function initKaching(kb, P, fmt, host) {
    var block = kb.querySelector('[data-cl-swatches]') || kb;
    var colors = {};
    try { colors = JSON.parse(block.getAttribute('data-cl-swatches') || '{}'); } catch (e) {}
    var gift = block.getAttribute('data-cl-gift-variant');
    // aria-expanded so enquanto aberto (fechado = sem o atributo): o dropdown e um listbox, nao um acordeao
    kb.querySelectorAll('.kaching-bundles__swatch-dropdown [role="combobox"]').forEach(function (c) { c.removeAttribute('aria-expanded'); });
    kb.addEventListener('focusout', function (e) { if (!kb.contains(e.relatedTarget)) setTimeout(function () { if (!kb.contains(document.activeElement)) closeDrops(); }, 150); });
    var names = (P.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var cIdx = names.map(norm).indexOf(norm('Farbe')), sIdx = names.map(norm).indexOf(norm('Größe'));
    function bars() { return [].slice.call(kb.querySelectorAll('.kaching-bundles__bar')); }
    function select(bar) {
      bars().forEach(function (b) { b.classList.toggle('kaching-bundles__bar--selected', b === bar); var r = b.querySelector('input[type="radio"]'); if (r) r.checked = b === bar; });
    }
    function variantFor(row) {
      var opts = [];
      var c = row.querySelector('.kaching-bundles__swatch-dropdown'), s = row.querySelector('select.kaching-bundles-option');
      return P.variants.filter(function (v) {
        return (cIdx < 0 || !c || norm(v.options[cIdx]) === norm(c.getAttribute('data-value'))) &&
               (sIdx < 0 || !s || norm(v.options[sIdx]) === norm(s.value));
      })[0];
    }
    function refreshRow(row) {
      var v = variantFor(row), img = row.querySelector('.kaching-bundles__bar-variant-image');
      if (v && img && v.featured_image) img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'height=200';
    }
    function closeDrops(except) {
      kb.querySelectorAll('.kaching-bundles__swatch-dropdown__options').forEach(function (o) { if (o !== except) { o.remove(); } });
      kb.querySelectorAll('.kaching-bundles__swatch-dropdown [role="combobox"]').forEach(function (c) { if (!except || !c.parentElement.contains(except)) c.removeAttribute('aria-expanded'); });
    }
    function swatchStyle(val) {
      var col = colors[val] || '#ccc';
      return '--kaching-swatch-size: 16px; --kaching-swatch-border-radius: 50%; --kaching-swatch-color: ' + col + '; --kaching-swatch-border-color: ' + (/^#?f{6}$/i.test(col.replace('#', '')) ? 'rgba(229, 229, 229, 1)' : col) + ';';
    }
    kb.addEventListener('click', function (e) {
      var opt = e.target.closest('.kaching-bundles__swatch-dropdown__option');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        var dd = opt.closest('.kaching-bundles__swatch-dropdown'), val = opt.getAttribute('data-value');
        dd.setAttribute('data-value', val);
        var cb = dd.querySelector('[role="combobox"]');
        cb.querySelector('span:last-of-type').textContent = val;
        var sw = cb.querySelector('.kaching-bundles__swatch'); if (sw) sw.setAttribute('style', swatchStyle(val));
        closeDrops();
        refreshRow(dd.closest('.kaching-bundles__bar-variant'));
        return;
      }
      var cb2 = e.target.closest('.kaching-bundles__swatch-dropdown [role="combobox"]');
      if (cb2) {
        e.preventDefault(); e.stopPropagation();
        var dd2 = cb2.parentElement, open = cb2.getAttribute('aria-expanded') === 'true';
        closeDrops();
        if (open) return;
        var list = document.createElement('div');
        list.className = 'kaching-bundles__swatch-dropdown__options'; list.setAttribute('role', 'listbox');
        var vals = cIdx < 0 ? [] : P.variants.map(function (v) { return v.options[cIdx]; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
        list.innerHTML = vals.map(function (v) {
          return '<span role="option" tabindex="-1" class="kaching-bundles__swatch-dropdown__option kaching-bundles-option-value" data-value="' + v.replace(/"/g, '&quot;') +
            '" aria-selected="' + (v === dd2.getAttribute('data-value')) + '"><div class="kaching-bundles__swatch" style="' + swatchStyle(v) + '"></div> <span>' + v + '</span></span>';
        }).join('');
        dd2.appendChild(list); cb2.setAttribute('aria-expanded', 'true');
        return;
      }
      if (e.target.closest('select')) return;
      var bar = e.target.closest('.kaching-bundles__bar');
      if (bar && !bar.classList.contains('kaching-bundles__bar--selected')) { select(bar); }
    }, true);
    kb.addEventListener('change', function (e) {
      var s = e.target.closest('select.kaching-bundles-option');
      if (s) { s.setAttribute('data-value', s.value); refreshRow(s.closest('.kaching-bundles__bar-variant')); }
    });
    document.addEventListener('click', function (e) { if (!kb.contains(e.target)) closeDrops(); });
    kb.__clItems = function () {
      var bar = kb.querySelector('.kaching-bundles__bar--selected') || bars()[0];
      var items = [];
      bar.querySelectorAll('.kaching-bundles__bar-variant').forEach(function (row) {
        var v = variantFor(row); if (v) items.push({ id: v.id, quantity: 1 });
      });
      // juntar a mesma variante numa linha
      var merged = {}; items.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + 1; });
      items = Object.keys(merged).map(function (id) { return { id: +id, quantity: merged[id] }; });
      if (gift && bar.querySelector('.kaching-bundles__free-gift')) items.push({ id: +gift, quantity: 1, properties: { _cl_gift: '1' } });
      return items;
    };
    host.__clKaching = kb;
  }
  // submit do form do buybox com Kaching: um /cart/add.js com todos os itens da barra (registrado ANTES da gaveta)
  window.addEventListener('submit', function (e) {
    var f = e.target, host = f && f.closest && f.closest('.cl-pdp-host');
    if (!host || !host.__clKaching || !f.action || f.action.indexOf('/cart/add') === -1) return;
    var items = host.__clKaching.__clItems();
    if (!items.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (window.clCart) return window.clCart.open(); location.href = '/cart'; })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Dieses Produkt konnte nicht hinzugefügt werden.'); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  function run() { document.querySelectorAll('.cl-pdp-host').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
